import api from '@/api';
import Context from '@/models/Context';
import Topic from '@/models/strategy/Topic';

const state = {
  isLoading: false,
  isUpdating: false,
  isDeleting: false,
  isFetched: false
};

// getters
const getters = {
  isLoading() {
    return state.isLoading;
  },

  isUpdating() {
    return state.isUpdating;
  },

  isDeleting(state) {
    return state.isDeleting;
  }
};

const mutations = {
  setLoading(state, value) {
    state.isLoading = value;
  },

  setUpdating(state, value) {
    state.isUpdating = value;
  },

  setDeleting(state, value) {
    state.isDeleting = value;
  },

  setFetched(state, value) {
    state.isFetched = value;
  }
};

// actions
const actions = {
  reset({ commit }) {
    commit('setLoading', false);
    commit('setUpdating', false);
    commit('setDeleting', false);
    commit('setFetched', false);
  },

  findForTeam({ commit, state, dispatch }) {
    if (!state.isFetched) {
      const domain = Context.query().first().domain;
      commit('setLoading', true);
      api.get(`/${domain}/topics`).then(response => {
        dispatch(
          'normalize',
          {
            model: Topic,
            data: response.data.data
          },
          { root: true }
        ).then(() => {
          commit('setLoading', false);
          commit('setFetched', true);
        });
      });
    }
  },

  create({ commit, dispatch }, newObject) {
    const domain = Context.query().first().domain;

    return new Promise(resolve => {
      commit('setUpdating', true);
      const topic = new Topic();
      topic.name = newObject.name;
      topic.posts = newObject.posts;
      topic.autoSubscribe = newObject.autoSubscribe;
      topic.parent_id = newObject.parent_id;
      topic.color = newObject.color;
      topic.groups_collection = newObject.groups_collection;

      api.create(`/${domain}/topics`, Topic, topic).then(response => {
        dispatch(
          'normalize',
          {
            model: Topic,
            data: response.data.data
          },
          { root: true }
        );
        commit('setUpdating', false);
        resolve();
      });
    });
  },

  remove({ commit }, collection) {
    return new Promise(resolve => {
      collection.forEach(topic => {
        commit('setDeleting', true);
        api.remove(Topic, topic).then(() => {
          Topic.delete(topic.id);
          commit('setDeleting', false);
          resolve();
        });
      });
    });
  },

  update({ commit }, topic) {
    return new Promise(resolve => {
      commit('setUpdating', true);

      api.update(Topic, topic).then(() => {
        commit('setUpdating', false);
        resolve();
      });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
